import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ProductDamageDomesticStepConfig: StepConfig = {
    type: FormType.PRODUCT_DAMAGE_DOMESTIC
};
